import React, { lazy } from "react";
import UIDs from "../../UIDs";

const FacilityAccessScreen = lazy(() => import("../../screens/admin/facility/FacilityAccessScreen"));
const FacilityRainOutListScreen = lazy(() => import("../../screens/admin/facility/FacilityRainOutListScreen"));
const ViewFacilityScreen = lazy(() => import("../../screens/admin/facility/ViewFacilityScreen"));
const FacilityLiveViewScreen = lazy(() => import("../../screens/admin/facility/FacilityLiveViewScreen"));
const EditFacilityAccessScreen = lazy(() => import("../../screens/admin/facility/EditFacilityAccessScreen"));
const EditFacilityScreen = lazy(() => import("../../screens/admin/facility/EditFacilityScreen"));
const EditFacilityAreaScreen = lazy(() => import("../../screens/admin/facility/EditFacilityAreaScreen"));
const FacilityAccessHistoryScreen = lazy(() => import("../../screens/admin/facility/FacilityAccessHistoryScreen"));
const FacilityCheckInScreen = lazy(() => import("../../screens/admin/facility/FacilityCheckInScreen"));
const MemberManagementScreen = lazy(() => import("../../screens/admin/network/MemberManagementScreen"));
const ActivateMembersScreen = lazy(() => import("../../screens/admin/network/ActivateMembersScreen"));
const MemberActivityHistoryScreen = lazy(() => import("../../screens/admin/network/MemberActivityHistoryScreen"));
const SignedWaiversScreen = lazy(() => import("../../screens/admin/network/SignedWaiversScreen"));
const ExportStatisticalReportScreen = lazy(() => import("../../screens/admin/network/ExportStatisticalReportScreen"));
const IntramuralsStatisticsScreen = lazy(() => import("../../screens/admin/network/IntramuralsStatisticsScreen"));
const ClubStatisticsScreen = lazy(() => import("../../screens/admin/network/ClubStatisticsScreen"));
const FitnessStatisticsScreen = lazy(() => import("../../screens/admin/network/FitnessStatisticsScreen"));
const ReservationStatisticsScreen = lazy(() => import("../../screens/admin/network/ReservationStatisticsScreen"));
const MarchMadnessScreen = lazy(() => import("../../screens/admin/network/MarchMadnessScreen"));
const SuspensionDetailScreen = lazy(() => import("../../screens/admin/network/SuspensionDetailScreen"));
const EditSuspensionScreen = lazy(() => import("../../screens/admin/network/EditSuspensionScreen"));
const SuspensionScreen = lazy(() => import("../../screens/admin/network/SuspensionScreen"));
const IneligibilityScreen = lazy(() => import("../../screens/admin/network/IneligibilityScreen"));
const TeamManagementScreen = lazy(() => import("../../screens/admin/network/TeamManagementScreen"));
const SidManagementScreen = lazy(() => import("../../screens/admin/network/SidManagementScreen"));
const SidImportScreen = lazy(() => import("../../screens/admin/network/SidImportScreen"));
const CreateAccountsScreen = lazy(() => import("../../screens/admin/network/CreateAccountsScreen"));
const AccountImportScreen = lazy(() => import("../../screens/admin/network/AccountImportScreen"));
const OfficialScreen = lazy(() => import("../../screens/admin/network/OfficialScreen"));
const OfficialSearchScreen = lazy(() => import("../../screens/admin/network/OfficialSearchScreen"));
const RefereeScreen = lazy(() => import("../../screens/admin/network/RefereeScreen"));
const FormManageScreen = lazy(() => import("../../screens/admin/club/FormManageScreen"));
const TravelRequestManageScreen = lazy(() => import("../../screens/admin/club/TravelRequestManageScreen"));
const TravelRequestsScreen = lazy(() => import("../../screens/admin/club/TravelRequestsScreen"));
const ViewFormResponsesScreen = lazy(() => import("../../screens/admin/club/ViewFormResponsesScreen"));
const MoveMembersScreen = lazy(() => import("../../screens/admin/network/MoveMembersScreen"));
const MoveTeamsScreen = lazy(() => import("../../screens/admin/network/MoveTeamsScreen"));
const MoveGamesScreen = lazy(() => import("../../screens/admin/network/MoveGamesScreen"));
const DashboardScreen = lazy(() => import("../../screens/admin/DashboardScreen.jsx"));
const OfferingsScreen = lazy(() => import("../../screens/portal/OfferingsScreen.jsx"));
const CalendarListScreen = lazy(() => import("../../screens/admin/eventcalendar/CalendarListScreen.jsx"));
const EditCalendarScreen = lazy(() => import("../../screens/admin/eventcalendar/EditCalendarScreen.jsx"));
const MessageCenterScreen = lazy(() => import("../../screens/admin/messagecenter/MessageCenterScreen"));
const MessageHistoryScreen = lazy(() => import("../../screens/admin/messagecenter/MessageHistoryScreen"));
const MessageHistoryDetailScreen = lazy(() => import("../../screens/admin/messagecenter/MessageHistoryDetailScreen"));

export const adminRoutes = [
    {
        path: "/dashboard",
        uid: UIDs.screens.admin.dashboard,
        layout: "/admin",
        element: DashboardScreen,
    },
    {
        path: "/facility/facilityaccess",
        uid: UIDs.screens.admin.facility.facilityaccess,
        layout: "/admin",
        element: FacilityAccessScreen ,
    },
    {
        path: "/facility/facilityliveview",
        uid: UIDs.screens.admin.facility.facilityliveview,
        layout: "/admin",
        element: FacilityLiveViewScreen,
    },
    {
        path: "/facility/editfacilityaccess",
        uid: UIDs.screens.admin.facility.editfacilityaccess,
        layout: "/admin",
        element: EditFacilityAccessScreen,
    },
    {
        path: "/facility/editfacility",
        uid: UIDs.screens.admin.facility.editfacility,
        layout: "/admin",
        element: EditFacilityScreen,
    },
    {
        path: "/facility/editfacilityarea",
        uid: UIDs.screens.admin.facility.editfacilityarea,
        layout: "/admin",
        element: EditFacilityAreaScreen,
    },
    {
        path: "/facility/facilityaccesshistory",
        uid: UIDs.screens.admin.facility.facilityaccesshistory,
        layout: "/admin",
        element: FacilityAccessHistoryScreen,
    },
    {
        path: "/facility/facilitycheckin",
        uid: UIDs.screens.admin.facility.facilitycheckin,
        layout: "/admin",
        element: FacilityCheckInScreen,
    },
    {
        path: "/facility/viewfacility",
        uid: UIDs.screens.admin.facility.viewfacility,
        layout: "/admin",
        element: ViewFacilityScreen,
    },
    {
        path: "/network/membermanagement",
        uid: UIDs.screens.admin.network.membermanagement,
        layout: "/admin",
        element: MemberManagementScreen,
    },
    {
        path: "/network/activatemembers",
        uid: UIDs.screens.admin.network.activatemembers,
        layout: "/admin",
        element: ActivateMembersScreen,
    },
    {
        path: "/network/memberactivityhistory",
        uid: UIDs.screens.admin.network.memberactivityhistory,
        layout: "/admin",
        element: MemberActivityHistoryScreen,
    },
    {
        path: "/network/signedwaivers",
        uid: UIDs.screens.admin.network.signedwaivers,
        layout: "/admin",
        element: SignedWaiversScreen,
    },
    {
        path: "/network/exportstatisticalreport",
        uid: UIDs.screens.admin.network.exportstatisticalreport,
        layout: "/admin",
        element: ExportStatisticalReportScreen,
    },
    {
        path: "/network/intramuralsstatistics",
        uid: UIDs.screens.admin.network.intramuralsstatistics,
        layout: "/admin",
        element: IntramuralsStatisticsScreen,
    },
    {
        path: "/network/clubstatistics",
        uid: UIDs.screens.admin.network.clubstatistics,
        layout: "/admin",
        element: ClubStatisticsScreen,
    },
    {
        path: "/network/fitnessstatistics",
        uid: UIDs.screens.admin.network.fitnessstatistics,
        layout: "/admin",
        element: FitnessStatisticsScreen,
    },
    {
        path: "/network/reservationstatistics",
        uid: UIDs.screens.admin.network.reservationstatistics,
        layout: "/admin",
        element: ReservationStatisticsScreen,
    },
    {
        path: "/network/marchmadness",
        uid: UIDs.screens.admin.network.marchmadness,
        layout: "/admin",
        element: MarchMadnessScreen,
    },
    {
        path: "/network/suspensiondetail",
        uid: UIDs.screens.admin.network.suspensiondetail,
        layout: "/admin",
        element: SuspensionDetailScreen,
    },
    {
        path: "/network/editsuspension",
        uid: UIDs.screens.admin.network.editsuspension,
        layout: "/admin",
        element: EditSuspensionScreen,
    },
    {
        path: "/network/suspensions",
        uid: UIDs.screens.admin.network.suspensions,
        layout: "/admin",
        element: SuspensionScreen,
    },
    {
        path: "/network/ineligibility",
        uid: UIDs.screens.admin.network.ineligibility,
        layout: "/admin",
        element: IneligibilityScreen,
    },
    {
        path: "/network/teammanagement",
        uid: UIDs.screens.admin.network.teammanagement,
        layout: "/admin",
        element: TeamManagementScreen,
    },
    {
        path: "/network/sidimport",
        uid: UIDs.screens.admin.network.sidimport,
        layout: "/admin",
        element: SidImportScreen,
    },
    {
        path: "/network/sidmanagement",
        uid: UIDs.screens.admin.network.sidmanagement,
        layout: "/admin",
        element: SidManagementScreen,
    },
    {
        path: "/network/createaccounts",
        uid: UIDs.screens.admin.network.createaccounts,
        layout: "/admin",
        element: CreateAccountsScreen,
    },
    {
        path: "/network/accountimport",
        uid: UIDs.screens.admin.network.accountimport,
        layout: "/admin",
        element: AccountImportScreen,
    },
    {
        path: "/network/addofficial",
        uid: UIDs.screens.admin.network.official,
        layout: "/admin",
        element: OfficialScreen,
    },
    {
        path: "/network/official",
        uid: UIDs.screens.admin.network.official,
        layout: "/admin",
        element: OfficialScreen,
    },
    {
        path: "/network/officialsearch",
        uid: UIDs.screens.admin.network.officialsearch,
        layout: "/admin",
        element: OfficialSearchScreen,
    },
    {
        path: "/network/referee",
        uid: UIDs.screens.admin.network.referee,
        layout: "/admin",
        element: RefereeScreen,
    },
    {
        path: "/club/formmanage",
        uid: UIDs.screens.admin.club.formmanage,
        layout: "/admin",
        element: FormManageScreen,
    },
    {
        path: "/club/viewformresponses",
        uid: UIDs.screens.admin.club.viewformresponses,
        layout: "/admin",
        element: ViewFormResponsesScreen,
    },
    {
        path: "/club/travelrequestmanage",
        uid: UIDs.screens.admin.club.travelrequestmanage,
        layout: "/admin",
        element: TravelRequestManageScreen,
    },
    {
        path: "/club/travelrequests",
        uid: UIDs.screens.admin.club.travelrequests,
        layout: "/admin",
        element: TravelRequestsScreen,
    },
    {
        path: "/network/moveteams",
        uid: UIDs.screens.admin.network.moveteams,
        layout: "/admin",
        element: MoveTeamsScreen,
    },
    {
        path: "/network/movegames",
        uid: UIDs.screens.admin.network.movegames,
        layout: "/admin",
        element: MoveGamesScreen,
    },
    {
        path: "/network/movemembers",
        uid: UIDs.screens.admin.network.movemembers,
        layout: "/admin",
        element: MoveMembersScreen,
    },
    // {
    //     path: "/sport/:sportId/moveteams",
    //     uid: UIDs.screens.admin.network.moveteams,
    //     layout: "/admin",
    //     element: MoveTeamsScreen,
    // },
    // {
    //     path: "/sport/:sportId/movegames",
    //     uid: UIDs.screens.admin.network.movegames,
    //     layout: "/admin",
    //     element: MoveGamesScreen,
    // },
    // {
    //     path: "/sport/:sportId/movemembers",
    //     uid: UIDs.screens.admin.network.movemembers,
    //     layout: "/admin",
    //     element: MoveMembersScreen,
    // },
    // {
    //     path: "/league/:leagueId/moveteams",
    //     uid: UIDs.screens.admin.network.moveteams,
    //     layout: "/admin",
    //     element: MoveTeamsScreen,
    // },
    // {
    //     path: "/league/:leagueId/movegames",
    //     uid: UIDs.screens.admin.network.movegames,
    //     layout: "/admin",
    //     element: MoveGamesScreen,
    // },
    // {
    //     path: "/league/:leagueId/movemembers",
    //     uid: UIDs.screens.admin.network.movemembers,
    //     layout: "/admin",
    //     element: MoveMembersScreen,
    // },
    // {
    //     path: "/division/:divisionId/moveteams",
    //     uid: UIDs.screens.admin.network.moveteams,
    //     layout: "/admin",
    //     element: MoveTeamsScreen,
    // },
    // {
    //     path: "/division/:divisionId/movegames",
    //     uid: UIDs.screens.admin.network.movegames,
    //     layout: "/admin",
    //     element: MoveGamesScreen,
    // },
    // {
    //     path: "/division/:divisionId/movemembers",
    //     uid: UIDs.screens.admin.network.movemembers,
    //     layout: "/admin",
    //     element: MoveMembersScreen,
    // },
    // {
    //     path: "/team/:teamId/moveteams",
    //     uid: UIDs.screens.admin.network.moveteams,
    //     layout: "/admin",
    //     element: MoveTeamsScreen,
    // },
    // {
    //     path: "/team/:teamId/movegames",
    //     uid: UIDs.screens.admin.network.movegames,
    //     layout: "/admin",
    //     element: MoveGamesScreen,
    // },
    // {
    //     path: "/team/:teamId/teammovemembers",
    //     uid: UIDs.screens.admin.network.teammovemembers,
    //     layout: "/admin",
    //     element: MoveMembersScreen,
    // },

    {
        path: "/offerings",
        uid: UIDs.screens.admin.offerings,
        layout: "/admin",
        element: OfferingsScreen,
        exact: true,
    },
    {
        path: "/eventcalendar/calendarlist",
        uid: UIDs.screens.admin.eventcalendar.calendarlist,
        layout: "/admin",
        element: CalendarListScreen,
    },
    {
        path: "/eventcalendar/editcalendar",
        uid: UIDs.screens.admin.eventcalendar.editcalendar,
        layout: "/admin",
        element: EditCalendarScreen,
    },
    {
        path: "/messagehistory",
        uid: UIDs.screens.admin.messagehistory,
        layout: "/admin",
        element: MessageHistoryScreen,
    },
    {
        path: "/messagecenter",
        uid: UIDs.screens.admin.messagecenter,
        layout: "/admin",
        element: MessageCenterScreen,
    },
    {
        path: "/messagehistorydetail",
        uid: UIDs.screens.admin.messagehistorydetail,
        layout: "/admin",
        element: MessageHistoryDetailScreen,
    },
    {
        path: "/facility/facilityrainoutlist",
        uid: UIDs.screens.admin.facility.facilityrainoutlist,
        layout: "/admin",
        element: FacilityRainOutListScreen,
    },
];

